import { IContractAccountsCollection } from '@models/contract.class';
import { createSelector } from '@ngrx/store';

import { IImmutableState } from 'src/shared/types/immutable-state';
import { AppState } from '../app-state';

type ImmutableContractAccountsCollection = IImmutableState<{
  data: IContractAccountsCollection;
}>;

export const selectContractAccountsFeature = (state: AppState) => {
  return state.contractAccountsCollection as any as ImmutableContractAccountsCollection;
};

export const selectContractAccountsCollection = createSelector(
  selectContractAccountsFeature,
  (state) => state.toJS().data,
);

export const selectContractAccountsRelation = createSelector(
  selectContractAccountsCollection,
  (state) => state.accountRelation,
);

export const selectContractAccountsContracts = createSelector(
  selectContractAccountsCollection,
  (state) => state.contracts,
);

export const selectContractsAccountsAccounts = createSelector(
  selectContractAccountsCollection,
  (state) => {
    return state.accounts;
  },
);
